import {
  Button,
  Card,
  CardContent,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  Link,
  Typography,
} from '@forgeglobal/design-framework';
import { FORGETRUST } from '@tcs/common/assets/constants';
import TransfersInCashButton from '@tcs/fund-account/components/molecules/TransfersInCashButton';
import React, { useState } from 'react';
import { useStyles } from './style';

const GridRow: React.FC<{
  column1: React.ReactElement;
  column2: React.ReactElement;
}> = ({ column1, column2 }) => {
  return (
    <>
      <Grid item container xs={12} md={8}>
        {column1}
      </Grid>
      <Grid item container xs={12} md={3} alignItems="center">
        {column2}
      </Grid>
    </>
  );
};

export const FundAccountSelectFundingSource: React.FC = () => {
  const classes = useStyles();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { PHONE, WELCOME_EMAIL } = FORGETRUST;

  return (
    <>
      <Dialog
        open={!!isModalOpen}
        transitionDuration={0}
        disableEnforceFocus
        maxWidth={false}>
        <DialogTitle onClose={() => setIsModalOpen(false)}>
          Fund your account with a rollover
        </DialogTitle>
        <DialogContent>
          <Typography variant="body1" className={classes.disclaimer}>
            <p>
              To roll cash over into your Forge Trust Co. IRA, please contact
              your current Retirement Plan Administrator and tell them you want
              to roll your account into an IRA. Your Retirement Plan
              Administrator will provide you with the necessary instructions to
              move forward.
            </p>
            <p>
              You will need to provide Forge Trust Co.’s{' '}
              <Link
                href="https://forgetrust.com/forms/delivery-information/"
                target="_blank">
                Delivery Information
              </Link>
              , which includes instructions for sending the funds via check or
              wire (additional wire fees may apply).
            </p>
            <p>
              If you need assistance through the rollover process, please do not
              hesitate to contact us at{' '}
              <Link href={`tel:+${PHONE}`}>{PHONE}</Link> or{' '}
              <Link href={`mailto:${WELCOME_EMAIL}`}>{WELCOME_EMAIL}</Link>.
            </p>
          </Typography>
          <div>
            <Button
              variant="contained"
              color="secondary"
              onClick={() => setIsModalOpen(false)}
              className={classes.modalButtons}>
              Exit
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      <Card>
        <CardContent className={classes.cardContent}>
          <p>
            Forge Trust offers a number of ways for you to conveniently and
            securely fund your account.
          </p>
          <p>
            Note: The time it takes for funds to reach your account will vary
            based upon the funding method selected and how the funds are sent.
          </p>
        </CardContent>
      </Card>
      <Card>
        <CardContent className={classes.cardContent}>
          <Grid container spacing={4}>
            <GridRow
              column1={
                <div>
                  <strong>Transfer cash from another IRA account</strong>
                  <p>Transfer cash from another firm.</p>
                </div>
              }
              column2={<TransfersInCashButton className={classes.button} />}
            />
            <Grid item xs={12}>
              <Divider />
            </Grid>
            <GridRow
              column1={
                <div>
                  <strong>Roll over cash from a retirement plan</strong>
                  <p>
                    Consolidate funds from retirement plans with former
                    employers, such as a 401(k), into your self-directed IRA.
                  </p>
                </div>
              }
              column2={
                <Button
                  className={classes.button}
                  onClick={() => setIsModalOpen(true)}>
                  Roll over cash
                </Button>
              }
            />
            <Grid item xs={12}>
              <Divider />
            </Grid>
            <GridRow
              column1={
                <div>
                  <strong>Make a new cash contribution</strong>
                  <p>
                    Make a new cash contribution into your account using check
                    or ACH.
                  </p>
                </div>
              }
              column2={
                <Button
                  className={classes.button}
                  onClick={() =>
                    window.open(
                      'https://forgetrust.com/forms/fund-your-account',
                      '_blank'
                    )
                  }>
                  Cash Contribution
                </Button>
              }
            />
          </Grid>
        </CardContent>
      </Card>
    </>
  );
};

export default FundAccountSelectFundingSource;
